import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    additionalinfo:{},
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantViewInstanceGuid}/{ViewInstanceName}/{ViewInstanceDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantViewInstanceGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{ViewInstanceName}/{ViewInstanceDescription}/	
export const fetchViewInstances = createAsyncThunk('viewinstance/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(WELLSUITE + "GetViewInstance/" + incomingVariable.authToken + "/"+incomingVariable.VIGuid +'/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})
export const fetchPublicViewInstances = createAsyncThunk('viewinstancepublic/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(WELLSUITE + "GetViewInstancePublic/" + incomingVariable.GroupGuid +"/"+incomingVariable.LanguageTypeId + "/"+incomingVariable.VIGuid +'/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const viewinstanceSlice = createSlice({
    name: 'viewinstances',
    initialState,
    reducers: {        
        viewinstanceClear(state, action) {
            delete state.entities[action.payload.ViewInstanceId]
        },
        viewinstanceClearAll(state, action) {
            state.entities = initialState
            state.status = "idle"
        },
        viewInstanceUpsert(state,action) {
            state.entities[action.payload.ViewInstanceId] = action.payload.ViewInstanceData
        },
        viewInstanceUpsertLevel1(state,action) {
            state.entities[action.payload.ViewInstanceId][action.payload.ViewInstanceKey] = action.payload.ViewInstanceValue
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchViewInstances.pending, (state, action) => {
                const ViewInstanceId = action.meta.arg.VIName
                const tmp = state.entities[ViewInstanceId] || {}
                state.entities[ViewInstanceId] = {...tmp, status:"loading"}
            })
            .addCase(fetchViewInstances.fulfilled, (state, action) => {
                state.status = 'success'
                
                const VIData = action.payload.Info[0].ViewInstanceData[0]
                const VIData2 = action.payload.Info[0].ViewInstanceData.length >1 ? action.payload.Info[0].ViewInstanceData[1] : {}
                const ViewInstanceId = action.meta.arg.VIName
                
                
                state.entities[ViewInstanceId] = {...VIData, ViewInstanceId:ViewInstanceId, settings:VIData2, status:"success"}
            })
            .addCase(fetchViewInstances.rejected, (state, action) => {
                const ViewInstanceId = action.meta.arg.VIName
                const tmp = state.entities[ViewInstanceId] || {}
                state.entities[ViewInstanceId] = {...tmp, status:"failed", error:action.error.message}
                
                
            })
            .addCase(fetchPublicViewInstances.pending, (state, action) => {
                const ViewInstanceId = action.meta.arg.VIName
                const tmp = state.entities[ViewInstanceId] || {}
                state.entities[ViewInstanceId] = {...tmp, status:"loading"}
            })
            .addCase(fetchPublicViewInstances.fulfilled, (state, action) => {
                state.status = 'success'
                const VIData = action.payload.Info[0].ViewInstanceData[0]
                const VIData2 = action.payload.Info[0].ViewInstanceData.length >1 ? action.payload.Info[0].ViewInstanceData[1] : {}
                const ViewInstanceId = action.meta.arg.VIName
                
                
                state.entities[ViewInstanceId] = {...VIData, ViewInstanceId:ViewInstanceId, settings:VIData2, status:"success"}
            })
            .addCase(fetchPublicViewInstances.rejected, (state, action) => {
                const ViewInstanceId = action.meta.arg.VIName
                const tmp = state.entities[ViewInstanceId] || {}
                state.entities[ViewInstanceId] = {...tmp, status:"failed", error:action.error.message}
            })
            
            
    }
})

export const { viewinstanceClear, viewinstanceClearAll, viewInstanceUpsert, viewInstanceUpsertLevel1} = viewinstanceSlice.actions

export default viewinstanceSlice.reducer

export const selectViewInstanceEntities = (state) => state.viewinstances.entities

export const selectViewInstances = createSelector(selectViewInstanceEntities, (entities) =>
    Object.values(entities)
)

export const selectViewInstanceById = (state, ViewInstanceId) => {
    return selectViewInstanceEntities(state)[ViewInstanceId]
}

